/* unplugin-vue-components disabled */import script from "./DeptTag.vue?vue&type=script&setup=true&lang=js"
export * from "./DeptTag.vue?vue&type=script&setup=true&lang=js"

import "./DeptTag.vue?vue&type=style&index=0&id=4ee6d5b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee6d5b0"]])

export default __exports__